
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { getMonthNameByNumber } from '@/utils/datetime';
import { Subscription } from '@/types/subscriptions';

@Component({
    components: {},
})
export default class PaymentMethodCard extends Vue {
    getMonthNameByNumber = getMonthNameByNumber;

    @Prop({ required: true })
    card!: any;

    @Prop({ required: true })
    onRemove!: (cardId: string) => void;

    @Prop({ required: true })
    onChange!: (cardId: string) => void;

    @State('subscriptions')
    userSubscriptions!: Subscription[];

    subscriptionExist = false;

    remove() {
        this.onRemove(this.card.id);
    }

    change() {
        this.onChange(this.card.id);
    }

    mounted() {
        this.subscriptionExist = this.userSubscriptions.length ? false : true;
    }
}
